export const projections = {
    layout: {
        indexTitle: 'Projeções',
        shortTermTitle: 'Curto Prazo',
        mediumTermTitle: 'Médio Prazo',
        whatIfTitle: 'Simulador',
    },
    hub: {
        projectedBalance: 'Saldo projetado',
        // Rótulo dinâmico igual ao topo da Home (ADR 0020): vira "Disponível" só quando há
        // caixinha — sem reserva, Disponível == saldo e o nome familiar fica.
        projectedAvailable: 'Disponível projetado',
        reservedNote: '{{amount}} guardado em caixinhas não entra',
        shortTermTitle: 'Curto Prazo',
        shortTermSubtitle: 'Projeção dia a dia (30-90 dias)',
        mediumTermTitle: 'Médio Prazo',
        mediumTermSubtitle: 'Cenários para 3-12 meses',
        whatIfTitle: 'Simulador What-If',
        whatIfSubtitle: 'E se eu adicionar/remover uma despesa?',
    },
    shortTerm: {
        period30: '30 dias',
        period60: '60 dias',
        period90: '90 dias',
        today: 'hoje',
        kickerBreach: 'Seu caixa não aguenta os {{days}} dias',
        kickerAlready: 'Antes mesmo dos próximos vencimentos',
        kickerSafe: 'Com o que já está agendado',
        headlineBreach: 'Fura em {{date}}',
        headlineAlready: 'Já está no vermelho',
        headlineSafe: 'Aguenta os {{days}} dias',
        detailShortfall: 'Faltam',
        detailSlack: 'Menor folga',
        detailRecovers: 'volta ao azul em {{date}}',
        detailNoRecovery: 'e não volta até o fim do período',
        detailSlackDate: 'em {{date}}',
        curveRecovery: 'volta ao azul em {{date}}',
        slackLabel: 'Menor folga',
        endsOn: 'Termina em {{date}}',
        actionSimulate: 'Simular os {{amount}}',
        actionPostpone: 'Adiar essa despesa',
        eventsTitle: 'O que acontece até {{date}}',
        runningBalance: 'saldo após',
        breachHere: 'é aqui que fura',
        source: {
            recurring: 'recorrente',
            invoice: 'fatura',
        },
        underwaterDays_one: 'abaixo de zero por {{count}} dia',
        underwaterDays_other: 'abaixo de zero por {{count}} dias',
        underwaterOpen: 'segue abaixo de zero até o fim do período',
        showAll_one: 'Ver mais {{count}} evento',
        showAll_other: 'Ver mais {{count}} eventos',
        showLess: 'Ver menos',
        note: 'Soma ao saldo de hoje tudo que já está agendado no período: recorrências, faturas em aberto e lançamentos pendentes das contas incluídas.',
        emptyTitle: 'Ainda sem base para projetar',
        emptySubtitle: 'Assim que houver contas, saldo e eventos financeiros suficientes, esta curva passa a mostrar o horizonte de curto prazo.',
        emptyEventsTitle: 'Sem eventos destacados neste horizonte',
        emptyEventsSubtitle: 'Se surgirem vencimentos, recorrências ou movimentos relevantes nos próximos dias, eles aparecem listados aqui.',
    },
    mediumTerm: {
        period3: '3 meses',
        period6: '6 meses',
        period12: '12 meses',
        kicker: 'Mantendo o ritmo atual',
        headlineTurns: '{{month}} fecha no vermelho',
        headlineStaysRed: 'Segue no vermelho até {{month}}',
        headlineHolds: 'Segue no azul por {{months}} meses',
        detailIn: 'Em {{month}}:',
        detailRange: 'entre {{low}} e {{high}}',
        legendLine: 'projeção',
        legendMargin: 'margem de erro (±{{amount}})',
        committedTitle: 'Quanto disso já está contratado',
        legendCommitted: 'contratado',
        legendEstimated: 'estimado',
        committedShare: '{{percent}} contratado',
        heaviestPairTitle: '{{first}} e {{second}} pesam juntos',
        heaviestPairSubtitle: '{{amount}} em compromissos já cadastrados',
        methodologyTitle: 'Como calculamos',
        emptyTitle: 'Ainda sem base para tendência',
        emptySubtitle: 'Quando houver histórico suficiente de entradas, saídas e saldo, a projeção e a margem de erro aparecem aqui.',
        chartFootnote: 'Soma os compromissos já cadastrados (recorrências, faturas e agendados) e estima o resto pela média dos últimos 3 meses. A faixa varia ±10% só na parte estimada — o que já está contratado não balança.',
    },
    whatIf: {
        typeAddExpense: 'Adicionar despesa',
        typeRemoveExpense: 'Cortar despesa',
        typeIncomeChange: 'Alterar renda',
        typeShortAdd: 'Adicionar',
        typeShortCut: 'Cortar',
        typeShortIncome: 'Alterar renda',
        actionAdd: 'Adicionando uma despesa',
        actionAddNamed: 'Adicionando {{name}}',
        actionCut: 'Cortando uma despesa',
        actionCutNamed: 'Cortando {{name}}',
        actionIncome: 'Alterando a renda',
        actionIncomeNamed: 'Alterando a renda · {{name}}',
        perWeek: '{{amount}}/semana',
        perMonth: '{{amount}}/mês',
        perYear: '{{amount}}/ano',
        frequencyWeekly: 'Semanal',
        frequencyMonthly: 'Mensal',
        frequencyAnnual: 'Anual',
        horizon6: '6 meses',
        horizon12: '12 meses',
        horizon24: '24 meses',
        scenarioNameAdd: 'Adicionar {{name}}',
        scenarioNameCut: 'Cortar {{name}}',
        scenarioNameIncome: 'Renda · {{name}}',
        scenarioFallback: 'Cenário',
        headline: 'Você termina {{month}} com {{amount}}',
        detailAbove: 'a mais que a trajetória de hoje',
        detailBelow: 'a menos que a trajetória de hoje',
        emptyKicker: 'Nenhum cenário ainda',
        emptyHeadline: 'E se você cortasse uma despesa?',
        emptyDetail: 'Escolha um valor abaixo para ver como sua trajetória muda.',
        setupTitle: 'O que simular',
        setupEmptyValue: 'Escolher',
        applySetup: 'Ver resultado',
        importSectionTitle: 'SUAS DESPESAS RECORRENTES',
        amountLabel: 'Valor',
        clearSelection: 'Limpar seleção',
        selectedExpenses_one: '{{count}} despesa',
        selectedExpenses_other: '{{count}} despesas',
        importEmpty: 'Nenhuma recorrência ou assinatura ativa para escolher.',
        save: 'Salvar',
        scenarioSaved: 'Cenário salvo',
        verdictClearsRed_one: 'Sai do vermelho: hoje {{first}} fecharia negativo — com esse cenário, nenhum mês fecha.',
        verdictClearsRed_other: 'Sai do vermelho: hoje você fecharia {{count}} meses negativos entre {{first}} e {{last}} — com esse cenário, nenhum.',
        verdictReducesRed: 'Alivia, mas não resolve: de {{from}} para {{to}} meses fechando no vermelho.',
        verdictCausesRed_one: 'Entra no vermelho: {{month}} passa a fechar negativo.',
        verdictCausesRed_other: 'Entra no vermelho: {{count}} meses passam a fechar negativo, a partir de {{month}}.',
        verdictWorsensRed: 'Aperta mais: de {{from}} para {{to}} meses fechando no vermelho.',
        verdictStaysRed_one: 'Não muda o essencial: {{count}} mês continua fechando no vermelho.',
        verdictStaysRed_other: 'Não muda o essencial: {{count}} meses continuam fechando no vermelho.',
        verdictStaysBlue: 'Nenhum mês fecha no vermelho nos próximos {{months}} meses — nem hoje, nem com esse cenário.',
        chipGoals: 'cobre {{amount}}/mês das metas',
        chipBudgets_one: '{{count}} orçamento em risco',
        chipBudgets_other: '{{count}} orçamentos em risco',
        chipInvoices: '{{amount}} em faturas abertas',
        chartBaselineBreach: 'hoje: vermelho em {{month}}',
        legendScenario: 'cenário',
        legendToday: 'hoje',
        deltaTitle: 'Diferença mês a mês',
        deltaFootnote: 'Acumula {{monthly}}/mês · {{total}} no fim',
        showNumbers: 'Ver números',
        hideNumbers: 'Ocultar',
        colMonth: 'MÊS',
        colCurrent: 'HOJE',
        colScenario: 'CENÁRIO',
        savedTitle: 'Cenários salvos',
        savedHint: 'toque para usar · deslize para excluir',
        useScenarioA11y: 'Usar cenário',
        compare: 'Comparar',
        stopComparing: 'Parar comparação',
        suggestionsTitle: 'Comece por uma despesa sua',
    },
};
